import React from 'react'
import { Accordion, Badge } from 'react-bootstrap'
import { BsCpu } from 'react-icons/bs'
import { MdChat, MdCheck, MdFolder, MdImage, MdSignalCellular0Bar, MdTextFormat, MdVoiceChat, MdVoiceOverOff } from 'react-icons/md'
import Agent0 from "Assets/Images/agent-0.png"
import Agent1 from "Assets/Images/agent-1.png"
import Agent2 from "Assets/Images/agent-2.png"
import Agent3 from "Assets/Images/agent-3.png"
import Agent4 from "Assets/Images/agent-4.png"
import Agent5 from "Assets/Images/agent-5.png"
export default function Agents() {
  return (
    <div className='container p-4' id="agents">
        <div className='row align-items-center'>
            <div className='col-md-6 p-2'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <h3 className='bold'>
                        <span className='m-2 text-primary'><BsCpu size={"35px"}/></span>
                        پرسنل دیجیتال
                    </h3>
                    <h3 className='bold text-muted'>Agents</h3>
                </div>
                <hr/>
                <p className='brand-p'>پرسنل دیجیتال، عامل های هوشمند شما هستند که می توانند از عملیات های ساده تا فرایندهای پیچیده روزانه شما را آموزش دیده و به بهترین نحو ممکن به انجام برسانند.آن ها خسته نمیشوند، گلایه نمیکنند و نیاز به خوردن و یا نوشیدن هم ندارند.
آن ها فقط نیاز به یک چیز دارند، فرمان شما‌!</p>
                <div className='d-flex flex-row justify-content-end'>
                   
                </div>
                <br/>
                <p className='bold'>
                    <span className='text-primary m-2'><MdTextFormat/></span>
                    پردازش متن
                </p>
                <p className='bold'>
                    <span className='text-primary m-2'><MdImage/></span>
                    پردازش تصویر
                </p>
                <p className='bold'>
                    <span className='text-primary m-2'><MdSignalCellular0Bar/></span>
                    پردازش صوت
                </p>
                <p className='bold'>
                    <span className='text-primary m-2'><MdFolder/></span>
                    پردازش فایل
                </p>
            </div>
            
            <div className='col-md-6 p-2'>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2'><img width={"30px"} src={Agent0}/></span>
                                مدیریت هوشمند منابع مالی
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                بودجه بندی
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                مدیریت درآمدها و هزینه ها
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                گزارشات مالی
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2'><img width={"30px"} src={Agent1}/></span>
                                مدیریت هوشمند زمان و برنامه ریزی
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                زمان بندی جلسات
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                هماهنگی با تقویم سازمانی
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                هشدارهای هوشمند
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2'><img width={"30px"} src={Agent2}/></span>
                                مدیریت هوشمند منابع انسانی
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                زمان بندی جلسات
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                هماهنگی با تقویم سازمانی
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                هشدارهای هوشمند
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2'><img width={"30px"} src={Agent3}/></span>
                                مدیریت هوشمند پروژه ها و وظایف
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                برنامه ریزی
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                تخصیص منابع
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                زمانبندی و پیگیری پیشرفت پروژه ها
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2'><img width={"30px"} src={Agent4}/></span>
                                ردیابی دارایی های سازمان
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                نگهداری دوره ای و تخصیص به افراد یا واحدها
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                گزارش گیری لحظه ای
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2'><img width={"30px"} src={Agent5}/></span>
                                اتوماسیون هوشمند فرایندها
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                طراحی و اجرای خودکار فرآیندهایی مثل تایید مرخصی، درخواست خرید، ثبت ماموریت.
                            </p>
                            <p className='bold brand-p'>
                                <span className='text-primary m-2'><MdCheck/></span>
                                صرفه‌جویی در زمان و کاهش خطای انسانی
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        </div>
    </div>
  )
}
